import { render } from "./OrderHistoryView.vue?vue&type=template&id=13ef30f8"
import script from "./OrderHistoryView.vue?vue&type=script&lang=js"
export * from "./OrderHistoryView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__